// src/services/platformNotificationsApi.ts
//
// API client for the platform-level notification endpoints
// (GET /notifications, GET /notifications/unread-count, etc.)
//
// Separate from brandNotificationsApi.ts which targets the support-ticket
// notification system at /support/notifications.

import api from './api'

// ── Types ────────────────────────────────────────────────────────────────────

export type PlatformNotificationType =
  | 'EXPIRY_ALERT'
  | 'LOW_BALANCE'
  | 'TOPUP_SUCCESS'
  | 'BLOG_GENERATED'
  | 'BLOG_GENERATION_FAILED'
  | 'SMM_CONTENT_GENERATED'
  | 'SMM_CONTENT_GENERATION_FAILED'

export interface PlatformNotification {
  id: number
  user_id: string
  type: PlatformNotificationType
  title: string
  message: string
  reference_id: string | null
  is_read: boolean
  read_at: string | null
  created_at: string
}

export interface UnreadCountResponse {
  unread_count: number
}

export interface MarkAllReadResponse {
  updated: number
}

// ── API calls ─────────────────────────────────────────────────────────────────

export const fetchPlatformNotifications = async (
  limit = 20,
  offset = 0,
): Promise<PlatformNotification[]> => {
  return api.get<PlatformNotification[]>(
    `/notifications?limit=${limit}&offset=${offset}`,
  )
}

export const fetchUnreadCount = async (): Promise<UnreadCountResponse> => {
  return api.get<UnreadCountResponse>('/notifications/unread-count')
}

export const markPlatformNotificationAsRead = async (
  id: number,
): Promise<PlatformNotification> => {
  return api.request<PlatformNotification>(`/notifications/${id}/read`, {
    method: 'POST',
  })
}

export const markAllPlatformNotificationsAsRead =
  async (): Promise<MarkAllReadResponse> => {
    return api.request<MarkAllReadResponse>('/notifications/mark-all-read', {
      method: 'POST',
    })
  }
